module.exports = __webpack_public_path__ + "static/media/mddus.ee701475.png";